import { IdentityDto } from './../shared';
import { EntityDto } from './../entity/entity.dto';

export class AccountingRuleFileDto {
  identity = new IdentityDto();
  entity = new EntityDto();
  fileS3Location: string;
  fileName: string;
  status: string;
  createdDate: string;
  createdBy: string;
  source: string;
  accountType: string;
  fileVersion: string;
  errors: string;
  ruleFileId: string;

  constructor(d?: AccountingRuleFileDto) {
    if (!d) {
      return;
    }
    this.identity = new IdentityDto(d.identity);
    this.entity = new EntityDto(d.entity);
    this.fileS3Location = d.fileS3Location;
    this.fileName = d.fileName;
    this.status = d.status;
    this.createdDate = d.createdDate;
    this.createdBy = d.createdBy;
    this.source = d.source;
    this.accountType = d.accountType;
    this.fileVersion = d.fileVersion;
    this.errors = d.errors;
    this.ruleFileId = d.ruleFileId;
  }
}
